import React from 'react';
import { ManualLayout } from '@/components/manual/ManualLayout';
import { MANUAL_SECTIONS } from '@/data/userManualContent';

// Full platform user manual (/help and /manual). Companion to the AssistantWidget.
export default function UserManual() {
  return (
    <ManualLayout
      sections={MANUAL_SECTIONS}
      title="Schedule Guru User Manual"
      subtitle="Every feature of the platform, in one place."
      updated="Jun 2026"
      seo={{
        title: 'User Manual | Schedule Guru',
        description: 'Complete user manual for Schedule Guru — every feature from creating schedules and running live stats to managing rosters, exporting data, and using Pro features.',
        path: '/help',
      }}
    />
  );
}
